import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    Button,
    Typography,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Alert
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import EventIcon from '@mui/icons-material/Event';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

class MonthlyMeetingList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            meetingInvite: '',
            groupId: this.props.groupId
        };
    }

    getMeetingDetails(groupId) {
        const details = {
            '5e2a5e764175b97d84ec6cae': {
                // Physical
                name: 'Physical Committee',
                url: 'https://sdsicinvites.s3.us-east-1.amazonaws.com/2026-physical-96136360159.ics',
                schedule: 'Third Thursday of every month',
                time: '10:30 AM - 11:30 AM EST',
                description: 'Monthly meeting to discuss physical infrastructure and security topics.'
            },
            '5e44050f4e6ed37ab467d0f2': {
                // Electrical
                name: 'Electrical Committee',
                url: 'https://sdsicinvites.s3.us-east-1.amazonaws.com/2026-electrical-96821287637.ics',
                schedule: 'Third Tuesday of every month',
                time: '1:30 PM - 2:30 PM EST',
                description: 'Monthly meeting to review electrical engineering projects and initiatives.'
            },
            '5e44052e4e6ed37ab467d0f3': {
                // Technology
                name: 'Technology Committee',
                url: 'https://sdsicinvites.s3.us-east-1.amazonaws.com/2026-technology-96208622419.ics',
                schedule: 'Third Wednesday of every month',
                time: '11:00 AM - 12:00 PM EST',
                description: 'Monthly meeting discussing latest tech trends and implementations.'
            },
            '5e4405864e6ed37ab467d0f4': {
                // Civil
                name: 'Civil Committee',
                url: 'https://sdsicinvites.s3.us-east-1.amazonaws.com/2026-civil97083009563.ics',
                schedule: 'Third Monday of every month',
                time: '4:00 PM - 5:00 PM EST',
                description: 'Monthly meeting to discuss structural engineering and civil projects.'
            },
            '5e4406454e6ed37ab467d0f5': {
                // Business Strategy
                name: 'Business Strategy Committee',
                url: 'https://sdsicinvites.s3.us-east-1.amazonaws.com/2026-business-97377646868-2.ics',
                schedule: 'First Tuesday of each Quarter',
                time: '12:00 PM - 1:00 PM EST',
                description: 'Quarterly meeting for strategic business planning and ROI discussions.'
            },
            '5e5591a97ff73f6d34835a05': {
                // Leadership
                name: 'Leadership Committee',
                url: 'https://sdsicinvites.s3.us-east-1.amazonaws.com/Leadership%2Bcommitee%2Bmonthly%2Bmeeting%2Binvite_25.ics',
                schedule: 'Second Thursday of every month',
                time: '2:00 PM - 3:00 PM EST',
                description: 'Monthly leadership meeting for strategic planning and consortium direction.'
            },
            '639242d4971a30726884fd85': {
                // Innovation
                name: 'Innovation Committee',
                url: 'https://sdsicinvites.s3.us-east-1.amazonaws.com/2026-innovation-95249217868.ics',
                schedule: 'Third Wednesday of every month',
                time: '1:00 PM - 2:00 PM EST',
                description: 'Monthly meeting to share innovative solutions and new ideas.'
            }
        };

        return details[groupId] || null;
    }

    render() {
        const { groupId } = this.state;
        const meetingDetails = this.getMeetingDetails(groupId);

        if (!meetingDetails) {
            return (
                <Alert severity="info">
                    No meeting invite available for this committee.
                </Alert>
            );
        }

        return (
            <Box>
                <Card elevation={3} sx={{ borderRadius: 3, overflow: 'hidden' }}>
                    {/* Header */}
                    <Box sx={{ backgroundColor: '#003E7E', color: 'white', p: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                            <EventIcon sx={{ fontSize: 40 }} />
                            <Box>
                                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                    {meetingDetails.name}
                                </Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                    2025 Monthly Zoom Meetings
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    <CardContent sx={{ p: 3 }}>
                        {/* Meeting Description */}
                        <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary', lineHeight: 1.6 }}>
                            {meetingDetails.description}
                        </Typography>

                        <Divider sx={{ mb: 3 }} />

                        {/* Meeting Details */}
                        <Paper elevation={1} sx={{ p: 2, mb: 3, backgroundColor: 'rgba(0, 62, 126, 0.05)' }}>
                            <List disablePadding>
                                <ListItem sx={{ px: 0 }}>
                                    <ListItemIcon sx={{ minWidth: 40 }}>
                                        <CalendarMonthIcon sx={{ color: '#003E7E' }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={<Typography variant="body2" sx={{ fontWeight: 600 }}>Schedule</Typography>}
                                        secondary={meetingDetails.schedule}
                                    />
                                </ListItem>
                                <ListItem sx={{ px: 0 }}>
                                    <ListItemIcon sx={{ minWidth: 40 }}>
                                        <AccessTimeIcon sx={{ color: '#003E7E' }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={<Typography variant="body2" sx={{ fontWeight: 600 }}>Time</Typography>}
                                        secondary={meetingDetails.time}
                                    />
                                </ListItem>
                                <ListItem sx={{ px: 0 }}>
                                    <ListItemIcon sx={{ minWidth: 40 }}>
                                        <VideoCallIcon sx={{ color: '#003E7E' }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={<Typography variant="body2" sx={{ fontWeight: 600 }}>Platform</Typography>}
                                        secondary="Zoom Video Conference"
                                    />
                                </ListItem>
                            </List>
                        </Paper>

                        {/* Instructions */}
                        <Alert severity="info" sx={{ mb: 3 }}>
                            <Typography variant="body2"> 
                                Download the Outlook calendar invite below to automatically add all 2025 monthly meetings to your calendar.
                                The invite includes Zoom meeting details and recurring event information.
                            </Typography>
                        </Alert>

                        {/* Download Button */}
                        <Button
                            href={meetingDetails.url}
                            variant="contained"
                            size="large"
                            startIcon={<DownloadIcon />}
                            fullWidth
                            sx={{
                                backgroundColor: '#FF6600',
                                py: 1.5,
                                '&:hover': {
                                    backgroundColor: '#e55a00'
                                }
                            }}
                        >
                            Download Outlook Calendar Invite (.ics)
                        </Button>

                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center', mt: 2 }}>
                            Compatible with Outlook, Google Calendar, Apple Calendar, and most calendar applications
                        </Typography>
                    </CardContent>
                </Card>
            </Box>
        );
    }
}

export default MonthlyMeetingList;